var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRainbowBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 15v45l-41.4 30H467a284.88 284.88 0 00-271 195.4 42.82 42.82 0 00-2.4 6.6 15.09 15.09 0 01-11.7 10.2c-27 5.4-49.2 24.6-57.3 50.7a15 15 0 01-7.5 9 17.8 17.8 0 01-6.9 1.5 13.59 13.59 0 01-4.8-.9c-4.2 0-7.2-1.5-10.2-4.5-2.7-3.3-3.3-7.2-3-11.4A374.31 374.31 0 01196 115.8C264.7 44.4 362 0 467 0h30a14.85 14.85 0 0115 15z",
    fill: "#f16523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 15v45l-41.4 30H467a284.88 284.88 0 00-271 195.4V115.8C264.7 44.4 362 0 467 0h30a14.85 14.85 0 0115 15z",
    fill: "#ee3d23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 60v60l-35.1 30H467c-95.7 0-182.2 61.6-213.7 151.9a14.88 14.88 0 01-8.7 9.3 17 17 0 01-5.4.9 15.08 15.08 0 01-7.2-1.8 79.29 79.29 0 00-36-9.3 77.77 77.77 0 00-14.4 1.2 15.1 15.1 0 01-13.8-4.8 15.51 15.51 0 01-3-14.4c7.8-24.9 18.3-49.3 31.2-70.9C251.8 118.8 353.9 60 467 60z",
    fill: "#fcd82d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 60v60l-35.1 30H467c-95.7 0-182.2 61.6-213.7 151.9a14.88 14.88 0 01-8.7 9.3 17 17 0 01-5.4.9 15.08 15.08 0 01-7.2-1.8 79.29 79.29 0 00-36-9.3v-88.9C251.8 118.8 353.9 60 467 60z",
    fill: "#f9bd13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 120c-108.6 0-206.2 69.7-241.9 172.3a15.06 15.06 0 006.9 18 71 71 0 0133.6 38.1c0 .3.3.9.3 1.2a11.09 11.09 0 011.5 3.3 15.41 15.41 0 0014.4 10.5 23.53 23.53 0 004.2-.6c.9-9 1.5-15.6 2.4-15.6A181 181 0 01467 195h45v-75z",
    fill: "#25d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 331a97.54 97.54 0 00-9.9.6 103.87 103.87 0 00-95.1-60.3h-.3a101.58 101.58 0 00-19.2 1.5 104.63 104.63 0 00-75.9 58.8c-3-.3-6.3-.6-9.6-.6-49.5 0-91 41.5-91 91s41.5 90 91 90h210c49.5 0 90-40.5 90-90s-40.5-91-90-91z",
    fill: "#e0f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 422c0 49.5-40.5 90-90 90H196V271.3a103.87 103.87 0 0195.1 60.3 97.54 97.54 0 019.9-.6c49.5 0 90 41.5 90 91z",
    fill: "#bdd9f1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5dc60",
    d: "M233.33 410.07h-30.25L213 363.4h-40.45l-13.88 65.33h31.11v46.67l43.55-65.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8e99b",
    d: "M203.08 410.07L213 363.4h-17v102.67l37.33-56h-30.25z"
  }))));
}

export default SvgRainbowBolt;